import {Injectable, OnInit} from '@angular/core';
import {PasswordSecurity} from '../../model/security/password-security';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordService {

  getFailureReason(passwordSecurity: PasswordSecurity, password: string, confirmPassword: string): { key: string, params: any } | undefined {
    if (!passwordSecurity) {
      return undefined;
    }
    if (password.length < passwordSecurity.length) {
      return {key: 'error.message.password_too_short', params: {value1: passwordSecurity.length}};
    }
    if (!this.checkLowerCase(passwordSecurity, password)) {
      return {key: 'error.message.password_no_lowercase', params: {value1: passwordSecurity.lowerCaseMin}};
    }
    if (!this.checkUpperCase(passwordSecurity, password)) {
      return {key: 'error.message.password_no_uppercase', params: {value1: passwordSecurity.upperCaseMin}};
    }
    if (!this.checkNumber(passwordSecurity, password)) {
      return {key: 'error.message.password_no_number', params: {value1: passwordSecurity.numericalMin}};
    }
    if (!this.checkSpecial(passwordSecurity, password)) {
      return {key: 'error.message.password_no_special', params: {value1: passwordSecurity.specialMin}};
    }
    if (password !== confirmPassword) {
      return {key: 'error.message.passwords_not_matched', params: {}};
    }
    return undefined;
  }

  checkPasswords(passwordSecurity: PasswordSecurity, password: string, confirmPassword: string) {
    let goodPassword = false;
    if (!passwordSecurity) {
      goodPassword=true;
    } else if (password === confirmPassword && this.checkLowerCase(passwordSecurity, password) &&
      this.checkUpperCase(passwordSecurity, password) &&
      this.checkNumber(passwordSecurity, password) &&
      this.checkSpecial(passwordSecurity, password) && password.length >= passwordSecurity.length) {
      goodPassword = true;
    }
    return goodPassword;
  }

  checkNumber(passwordSecurity: PasswordSecurity, password: string) {
    let hasNumber = false;
    // @ts-ignore
    if (passwordSecurity.numericalMin === 0
      || (password.match(/\d/g)
        && password.match(/\d/g).length >= passwordSecurity.numericalMin)) {
      hasNumber = true;
    }
    return hasNumber;
  }

  checkUpperCase(passwordSecurity: PasswordSecurity, password: string) {
    let hasUpper = false;
    if (!passwordSecurity.upperCaseMin || passwordSecurity.upperCaseMin === 0
      || (password.match(/[A-Z]/g)
        && password.match(/[A-Z]/g).length >= passwordSecurity.upperCaseMin)) {
      hasUpper = true;
    }
    return hasUpper;
  }

  checkLowerCase(passwordSecurity: PasswordSecurity, password: string) {
    let hasLower = false;
    if (!passwordSecurity.lowerCaseMin || passwordSecurity.lowerCaseMin === 0
      || (password.match(/[a-z]/g)
        && password.match(/[a-z]/g).length >= passwordSecurity.lowerCaseMin)) {
      hasLower = true;
    }
    return hasLower;
  }

  checkSpecial(passwordSecurity: PasswordSecurity, password: string) {
    let hasSpecial = false;
    const specialCount = (password.match(/[^a-zA-Z0-9]/g) || []).length;
    if (passwordSecurity.specialMin === 0 || specialCount >= passwordSecurity.specialMin) {
      hasSpecial = true;
    }
    return hasSpecial;
  }

}
